import React from 'react';
import { FaLinkedinIn, FaTwitter, FaEnvelope } from 'react-icons/fa';
import '../styles/OurTeam.css';

const OurTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Dr. Bhushan Patil",
      role: "Managing Director",
      bio: "PhD in Pharmaceutical Chemistry with 23 years of experience. Expert in process development and pharmaceutical production, leading innovation in women's healthcare.",
      image: "assets/member2.jpg"
    },
    {
      id: 2,
      name: "Mrs. Monali Patil",
      role: "Director",
      bio: "Experienced entrepreneur with 7 years in pharmaceutical marketing. Leading strategic initiatives and business development at Dr BhuPat Pharma.",
      image: "assets/member1.jpg"
    },
    {
      id: 3,
      name: "Mr. Sanjay Sontakke",
      role: "Sales Head",
      bio: "With over 22 years of rich experience in marketing and field force management, Mr. Sanjay Sontakke brings a wealth of industry knowledge and leadership to Dr. BhuPat Pharma Pvt. Ltd. Throughout his career, he has been associated with five reputed companies in the pharmaceutical and healthcare sector, where he played a key role in building and driving high-performing marketing teams.",
      image: "assets/member3.jpg"
    },
    {
  "id": 4,
  "name": "Mr. Abhishek Dhokte",
  "role": "HR and Logistic Head",
  "bio": "With extensive experience in human resources and logistics management, Mr. Abhishek Dhokte plays a pivotal role in streamlining operations and fostering a productive work environment at Dr. BhuPat Pharma Pvt. Ltd. His expertise in talent acquisition, employee engagement, and supply chain optimization has been instrumental in driving organizational efficiency and growth.",
  "image": "assets/member4.jpg"
}
  ];

  return (
    <div className="team-page">
      <section className="team-section">
        <div className="section-titleot">
          <h2>Our Leadership Team</h2>
          <p className="subtitleot">
            Meet the dedicated professionals leading Dr. BhuPat Pharma towards excellence in women's healthcare.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>
      </section>
    </div>
  );
};

const TeamCard = ({ member }) => {
  return (
    <div className="team-card">
      <div className="member-image">
        <img src={member.image} alt={member.name} />
      </div>
      <div className="member-info">
        <h3 className="member-name">{member.name}</h3>
        <p className="member-role">{member.role}</p>
        <p className="member-bio">{member.bio}</p>
        <div className="social-links">
          <a href="#" className="social-link" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href="#" className="social-link" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="#" className="social-link" aria-label="Email">
            <FaEnvelope />
          </a>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;